import "./landingFooter.css";

import ryseLogo from "../../assets/images/ryse_icon.png";
import { useLocation, useNavigate } from "react-router-dom";

const REDIRECTS = {
  "inst-manager": {
    url: "/redirections/InstutionalManager_PortfolioAssesment/index.html",
    newTab: true
  },
  "our-portfolio": {
    url: "/redirections/Our_Portfolio/index.html",
    newTab: true
  },
  "agentic-ecosystem": {
    url: "/redirections/AgenticPortfolioManagementEcosystem/index.html",
    newTab: true
  },
  architecture: {
    url: "/architecture-of-platform",
    newTab: false
  },
  robustness: {
    url: "/robustness-of-ryse-methodology",
    newTab: false
  },
  "multi-asset": {
    url: "/multi-asset-class-support",
    newTab: false
  },
  "client-references": {
  url: "/redirections/ClientReferences/index.html",
  newTab: true
  },
  "human-vs-ai": {
    url: "https://jbai.ai/cost-of-expertise-humans-vs-ai-agents",
    newTab: true
  }
};

const FOOTER_COLUMNS = [
  {
    id: "home",
    title: "Home",
    items: []
  },
  {
    id: "learnMore",
    title: "Learn More about Ryse",
    items: [
      { id: "inst-manager", label: "Instutional Manager - Portfolio Assesment" },
      { id: "our-portfolio", label: "Our Portfolio" },
      { id: "agentic-ecosystem", label: "Agentic Portfolio Management Ecosystem" },
      { id: "client-references", label: "Client References" },
      { id: "human-vs-ai", label: "Human vs AI" }
    ]
  },
  {
    id: "technical",
    title: "Technical Details",
    items: [
      { id: "architecture", label: "Architecture of Platform" },
      { id: "robustness", label: "Robustness of Ryse Methodology" },
      { id: "multi-asset", label: "The Multi-Asset Class Investment Platform" }
    ]
  },
  {
    id: "contact",
    title: "Contact",
    items: [
      { id: "email", label: "mario@ryseinc.com" }
    ]
  }
];

export default function LandingFooter() {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  const handleHomeClick = () => {
    if (location.pathname === "/") {
      scrollTop();
    } else {
      scrollTop();
      navigate("/");
    }
  };

  const handleRedirect = (itemId) => {
    const cfg = REDIRECTS[itemId];
    if (!cfg) return;

    if (cfg.newTab) {
      window.open(cfg.url, "_blank", "noopener,noreferrer");
    } else {
      scrollTop();
      navigate(cfg.url);
    }
  };

  const handleClick = (columnId, itemId) => {
    if (columnId === "home") {
      handleHomeClick();
      return;
    }

    if (columnId === "contact" && itemId === "email") {
      window.location.href = "mailto:mario@ryseinc.com";
      return;
    }

    handleRedirect(itemId);
  };

  return (
    <footer className="ryse-footer">
      <div className="ryse-footer__inner">
        <div className="ryse-footer__logo-block">
          <img src={ryseLogo} alt="Ryse" className="ryse-footer__logo" />
        </div>

        <div className="ryse-footer__columns">
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.id} className="ryse-footer__column">
              <h4
                className={`ryse-footer__column-title ${
                  col.id === "home" ? "ryse-footer__column-title--link" : ""
                }`}
                onClick={col.id === "home" ? handleHomeClick : undefined}
              >
                {col.title}
              </h4>

              <ul className="ryse-footer__list">
                {col.items.map((item) => (
                  <li key={item.id} className="ryse-footer__list-item">
                    <button
                      type="button"
                      className="ryse-footer__link"
                      onClick={() => handleClick(col.id, item.id)}
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
}
